"use client";

import "./index.scss";

export default function PaginationDots({
  numberOfPages,
  currentPage,
  goToPage,
}: {
  numberOfPages: number;
  currentPage: number;
  goToPage: (page: number) => void;
}) {
  return (
    <div className="component pagination-dots">
      {Array.from({ length: numberOfPages }).map((_, index) => (
        <button
          key={index}
          className={index === currentPage ? "active" : ""}
          onClick={() => goToPage(index)}
          aria-label={`Go to page ${index + 1}`}
        />
      ))}
    </div>
  );
}
